import { render, staticRenderFns } from "./Weekproduct.vue?vue&type=template&id=3aafb0c8&scoped=true&"
import script from "./Weekproduct.vue?vue&type=script&lang=js&"
export * from "./Weekproduct.vue?vue&type=script&lang=js&"
import style0 from "./Weekproduct.vue?vue&type=style&index=0&id=3aafb0c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafb0c8",
  null
  
)

export default component.exports